/**
 * Ruta que abre la ficha de un cliente.
 *
 * El router define `clientes` sin hijo `:id`, así que la ficha se abre con query params sobre
 * la ruta índice: `/clientes?id=<uuid>&ficha=<pestaña>`. `Clientes.tsx` lee `id` y `ficha`.
 *
 * Este archivo no importa con `@/` porque también lo bundlean las Netlify Functions.
 */
export const rutaFichaCliente = (clienteId: string, ficha?: string): string => {
  const params = new URLSearchParams({ id: clienteId })
  if (ficha) params.set('ficha', ficha)
  return `/clientes?${params.toString()}`
}

/** Acciones que `Clientes.tsx` atiende antes que la ficha: abren un diálogo sobre el cliente. */
export type AccionCliente = 'editar' | 'estado-cuenta'

/** Ruta que abre un diálogo de acción sobre un cliente: `/clientes?id=<uuid>&<accion>=true`. */
export const rutaAccionCliente = (clienteId: string, accion: AccionCliente): string => {
  const params = new URLSearchParams({ id: clienteId })
  params.set(accion, 'true')
  return `/clientes?${params.toString()}`
}
